import React, { useState } from "react";
import { MenuModel } from "../../../../../store/api/upsellApi";
import { Box, Button, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import _ from "lodash";
import AsynchronousAutocomplete from "../../../../../components/Autocomplete/AsynchronousAutocomplete";
import { useDialog } from "../Dialogs";

function PickMenuDialog({
  onAdd,
  allowMultiple,
  menuSalesareaId,
}: {
  onAdd: (p: MenuModel[]) => void;
  allowMultiple: boolean;
  menuSalesareaId: number;
}) {
  const [menus, setMenus] = useState<MenuModel[]>([]);

  return (
    <Box sx={{ width: "480px" }}>
      <DialogTitle>Add a menu</DialogTitle>
      <DialogContent>
        <AsynchronousAutocomplete
          async={{
            url: `core/kaarten/search?fields=id,id as value,id,naam as label,vestiging_id,naam,sortkey,is_actief,blocked&sort_field=naam&sort_dir=asc&vestiging_id=${menuSalesareaId}`,
            searchField: "naam",
          }}
          multiple={allowMultiple}
          onChange={(e, newMenu) => {
            if (newMenu) {
              if (_.isArray(newMenu)) {
                setMenus(newMenu);
              } else {
                setMenus([newMenu]);
              }
            } else {
              setMenus([]);
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          color={"success"}
          disabled={menus.length === 0}
          onClick={() => {
            onAdd(menus);
          }}
          variant={"contained"}
        >
          Add
        </Button>
      </DialogActions>
    </Box>
  );
}

export const NO_MENU_SELECTED = Symbol("No product selected");

export default function usePickMenu({
  allowMultiple,
  menuSalesareaId,
}: {
  allowMultiple: boolean;
  menuSalesareaId: number;
}) {
  const { createDialog, closeDialog } = useDialog();

  return () => {
    return new Promise<MenuModel[] | typeof NO_MENU_SELECTED>((resolve, reject) => {
      createDialog({
        afterClosing: () => {},
        onClose: () => {
          resolve(NO_MENU_SELECTED);
          closeDialog("select-menu-dialog");
        },
        name: "select-menu-dialog",
        children: (
          <PickMenuDialog
            allowMultiple={allowMultiple}
            menuSalesareaId={menuSalesareaId}
            onAdd={function (menus) {
              resolve(menus);
              closeDialog("select-menu-dialog");
            }}
          />
        ),
      });
    });
  };
}
